import React, { createContext, useContext, useState, useCallback } from 'react';
import i18n from '../../i18n';

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
    const [lang, setLang] = useState(() => {
        return sessionStorage.getItem('lang') || 'it';
    });

    const toggleLang = useCallback(() => {
        const next = lang === 'it' ? 'en' : 'it';
        setLang(next);
        sessionStorage.setItem('lang', next);
        i18n.changeLanguage(next);
    }, [lang]);

    return (
        <LanguageContext.Provider value={{ lang, toggleLang }}>
            {children}
        </LanguageContext.Provider>
    );
}

export function useLang() {
    return useContext(LanguageContext);
}
